module.exports = __webpack_public_path__ + "270cf1b06aa8bc0eb85f08eea2ffc3f0.jpg";